import React from 'react';
import ProjectTable from './projectTable';

const ProjectList = ({
    data,
    width,
    setProject,
    selected,
}) => {
    return (
        <div className="app-main-content">
            <ProjectTable
                selected={selected}
                data={data}
                width={width}
                setProject={setProject}
            />
        </div>
    );
};

export default ProjectList;


// WEBPACK FOOTER //
// ./components/Agile/project/projectList/index.js